import { render } from "./HeroiconsOutlineChevronDown.vue?vue&type=template&id=2c607ac2"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDown.vue"]])

export default __exports__